/**
 * Krok GPS1 — hranice Ceske republiky a obalka CR.
 *
 * ROZHODNUTI GPS1: „bod mimo CR" se posuzuje obalkou, ne presnou hranici.
 * Presna hranice je lomena cara se stovky vrkolu a parser, ktery by ji musel
 * obkreslit, by byl vetsi nez cela logika rozpoznani formatu. Uzivatel, ktery
 * posle `50.200340, 15.176310`, chce vedet JESTLI je to v CR — hranice CR
 * (zhruba lat 48.55–51.06, lon 12.09–18.86) je pro tenhle dotaz dost
 * presna. Obalka ma rezervu ~0.2 stupne, aby neselhala na bodu presne na
 * hranici (Krasna u Ase, Bukovec na Moravskem Beskydku).
 *
 * POZOR: obalka NENI overeni, ze bod lezi v digitalni mape. To delaji az
 * sluzby (`/v1/parcels/from-coords`, `/v1/duediligence/map/parcel-at-point`)
 * a uzivatel je potvrzuje — pravidlo „nepotvrzeny bod do objednavky nejde"
 * (krok W5) zustava nedotcene.
 */
/** Obalka CR — zemepna sirka. */
export const CZ_LAT_MIN = 48.3;
export const CZ_LAT_MAX = 51.3;
/** Obalka CR — zemepna delka. */
export const CZ_LON_MIN = 11.8;
export const CZ_LON_MAX = 19.0;
export const CZECHIA_BOUNDS = {
    latMin: CZ_LAT_MIN,
    latMax: CZ_LAT_MAX,
    lonMin: CZ_LON_MIN,
    lonMax: CZ_LON_MAX,
};
/** Bod lezi v obalce CR. Hranice se pocita jako IN — bod presne na ni je v CR. */
export function isWithinCzechia(point) {
    return (Number.isFinite(point.lat) &&
        Number.isFinite(point.lon) &&
        point.lat >= CZ_LAT_MIN &&
        point.lat <= CZ_LAT_MAX &&
        point.lon >= CZ_LON_MIN &&
        point.lon <= CZ_LON_MAX);
}
/**
 * Obalka CR pro mapu — stejne cisla jako `isWithinCzechia`, aby „prazdna mapa"
 * a „bod mimo CR" nekreslily dve ruzne hranice.
 */
export const CZECHIA_LAT_RANGE = [CZ_LAT_MIN, CZ_LAT_MAX];
export const CZECHIA_LON_RANGE = [CZ_LON_MIN, CZ_LON_MAX];
//# sourceMappingURL=bounds.js.map